module.exports = __webpack_public_path__ + "img/keyResultsIcon.65e0830a.svg";